import { useState } from 'react';
import { Marker, Popup } from 'react-map-gl/mapbox';
import type { Launchpad } from '../../../../types/gcs/launchpad';
import { getMapElementZIndex, MapElement } from '../../../../types/ui/mapElement';
import { Text } from '../../../../components/general/Text';
import { en } from '../../../../locales/en';
import { formatCoordinates } from '../../../../utils/formatters';

interface LaunchpadMarkerProps {
  gcsId: string;
  launchpad: Launchpad;
}

export const LaunchpadMarker = ({ gcsId, launchpad }: LaunchpadMarkerProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <Marker
        key={`launchpad-${gcsId}-${launchpad.id}`}
        longitude={launchpad.location.lng}
        latitude={launchpad.location.lat}
        anchor='center'
        style={{ zIndex: getMapElementZIndex(MapElement.LAUNCHPAD) }}
      >
        <div
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            backgroundColor: '#B2B2B2',
            border: '2px solid white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }}
          onClick={(event) => {
            event.stopPropagation();
            setIsPopupOpen((prev) => !prev);
          }}
        >
          <Text variant='body1-bold' style={{ color: 'white' }}>
            {launchpad.letter}
          </Text>
        </div>
      </Marker>
      {isPopupOpen && (
        <Popup
          longitude={launchpad.location.lng}
          latitude={launchpad.location.lat}
          anchor='bottom'
          offset={32}
          className='marker-popup'
          closeButton={true}
          closeOnClick={true}
          onClose={() => setIsPopupOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Text variant='body2'>
              {en.mapMarkers.launchpad} {launchpad.letter}
            </Text>
            <Text variant='body2' as='div'>
              {formatCoordinates(launchpad.location.lat, launchpad.location.lng, 6)}
            </Text>
          </div>
        </Popup>
      )}
    </>
  );
};
